import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { formatTRY } from "@/lib/format";

export default function ExpenseQuick({ line, accountId, onClose, onDone }) {
  const [cats, setCats] = useState([]);
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState(line.desc || "Banka gideri");
  useEffect(() => { api.get("/finans/meta").then(({ data }) => { setCats(data.categories); setCategory(data.categories[0]); }); }, []);
  const save = async () => {
    try {
      await api.post("/finans/expenses", { account_id: accountId, amount: Math.abs(line.amount), date: line.date, category, description });
      toast.success("Gider kaydedildi"); onDone();
    } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <Dialog open onOpenChange={onClose}><DialogContent data-testid="bankrecon-expense-dialog">
      <DialogHeader><DialogTitle>Gider/Ödeme oluştur · {formatTRY(Math.abs(line.amount))} · {line.date}</DialogTitle></DialogHeader>
      <select className="h-9 rounded border px-2" value={category} onChange={(e) => setCategory(e.target.value)} data-testid="bankrecon-expense-category">{cats.map((c) => <option key={c}>{c}</option>)}</select>
      <input className="h-9 rounded border px-2" value={description} onChange={(e) => setDescription(e.target.value)} data-testid="bankrecon-expense-desc" />
      <Button onClick={save} disabled={description.length < 3} data-testid="bankrecon-expense-save">Kaydet</Button>
    </DialogContent></Dialog>
  );
}
